import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';
import { Form } from '../../shared/form';

import { EffortItem, EffortFilter } from '../../_models/effort-item';
import { EffortService } from '../../_services/effort.service';

import { NotificationsService } from '../../_services/notifications.service';
import { Profile } from '../../_models/profile';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { GesteffortService } from 'app/_services/gesteffort.service';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ReturnStatement } from '@angular/compiler';

@Component({
  selector: 'app-effort-list',
  templateUrl: './effort-list.component.html',
  styleUrls: ['./_effort-list.component.scss'],
})
export class EffortListComponent extends List implements OnInit {
  public static currentYear = new Date().getFullYear();
  public profile: Profile;
  errorMessage: string;
  filter: EffortFilter;
  protected form: FormGroup;
  protected httpError: HttpErrorHandler;
  loading = false;

  initialEffort = new FormArray([]);

  private initialValues: Array<{
    id: Number;
    amount_shore: Number;
    amount_deep: Number;
    updating_shore: Boolean;
    updating_deep: Boolean;
  }> = [];

  constructor(
    private effortService: EffortService,
    private gesteffortService: GesteffortService,
    private router: Router,
    private route: ActivatedRoute,
    protected notificationsService: NotificationsService,
    private fb: FormBuilder
  ) {
    super(effortService, new EffortItem(), router, route);
    this.form = this.fb.group({
      initialEffort: this.fb.array([]),
    });
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.filter = new EffortFilter();
    this.defaultFilterParams = `year=${EffortListComponent.currentYear}`;
    this.params['year'] = EffortListComponent.currentYear;
    this.initList('efforts', this.filter).then((result) => {
      // console.log(this.collection)
      if (this.profile.haveAccess('gestesfuerzos')) {
        this.getGestEfforts(this.defaultFilterParams);
      }
      this.getInitialValues();
    });
    this.defaultFilterParams = '';
  }

  getGestEfforts(params) {
    this.gesteffortService.list(1, 10000, params, '').subscribe(
      (response) => {
        for (const gesteffort of response) {
          for (const effort of this.collection) {
            if (Number(effort.ship.id) === Number(gesteffort.ship.id) && Number(effort.year) === Number(gesteffort.year)) {
              if (gesteffort.fishing_type === 'COSTERA MIXTA') {
                effort.gesteffort_shore_consumed = this.format_number(Number(gesteffort.consumed_days));
                effort.gesteffort_shore_date = gesteffort.last_update;
              } else if (gesteffort.fishing_type === 'DE PROFUNDIDAD') {
                effort.gesteffort_deep_consumed = this.format_number(Number(gesteffort.consumed_days));
                effort.gesteffort_deep_date = gesteffort.last_update;
              }
            }
          }
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getInitialValues() {
    const init = this.form.controls.initialEffort as FormArray;
    for (const effort of this.collection) {
      effort.amount_shore = this.format_number(Number(effort.amount_shore));
      effort.amount_deep = this.format_number(Number(effort.amount_deep));
      this.remainigEffort(effort);
      init.push(
        this.fb.group({
          id: effort.id,
          amount_shore: new FormControl(Number(effort.amount_shore)),
          amount_deep: new FormControl(Number(effort.amount_deep)),
        })
      );
      this.initialValues.push({
        id: effort.id,
        amount_shore: effort.amount_shore,
        amount_deep: effort.amount_deep,
        updating_deep: false,
        updating_shore: false,
      });
    }
  }
  remainigEffort(ef) {
    ef.pending_shore = ef.amount_shore - ef.consumed_ar[0];
    ef.pending_deep = ef.amount_deep - ef.consumed_ar[1];
  }
  format_number(n) {
    if (n - Math.trunc(n) > 0) {
      return n.toFixed(1);
    } else {
      return n.toFixed(0);
    }
  }
  edit(id, effortType) {
    const effortSelected = this.collection.find((e) => e.id === id);

    for (const eff of this.collection) {
      if (eff.isEditingShore) {
        const initialEffort = this.initialValues.find((e) => e.id === eff.id);
        if (eff.amount_shore !== this.initialValues.find((e) => e.id === eff.id)) {
          eff.amount_shore = initialEffort.amount_shore;
        }
        eff.isEditingShore = !eff.isEditingShore;
      }
      if (eff.isEditingDeep) {
        const initialEffort = this.initialValues.find((e) => e.id === eff.id);
        if (eff.amount_deep !== this.initialValues.find((e) => e.id === eff.id)) {
          eff.amount_deep = initialEffort.amount_deep;
        }
        eff.isEditingDeep = !eff.isEditingDeep;
      }
    }

    if (effortType === 'shore') {
      effortSelected.isEditingShore = !effortSelected.isEditingShore;
    } else if ((effortType = 'deep')) {
      effortSelected.isEditingDeep = !effortSelected.isEditingDeep;
    }
  }
  update(id, effortType) {
    const effortSelected = this.collection.find((e) => e.id === id);
    // Upload only if data is integer or 0.5
    if (effortSelected.amount_shore % 0.5 !== 0 || effortSelected.amount_deep % 0.5 !== 0) {
      return;
    }

    if (effortType === 'shore') {
      if (!effortSelected.updating_shore) {
        effortSelected.updating_shore = true;
        this.effortService.update(effortSelected).subscribe(
          (effort) => {
            this.initialValues.find((e) => e.id === id).amount_shore = effortSelected.amount_shore;
            effortSelected.isEditingShore = !effortSelected.isEditingShore;
            this.remainigEffort(effortSelected);
            effortSelected.updating_shore = false;
          },
          (error) => {
            effortSelected.amount_shore = this.initialValues.find((e) => e.id === id).amount_shore;
          }
        );
      }
    } else if (effortType === 'deep') {
      if (!effortSelected.updating_deep) {
        effortSelected.updating_deep = true;
        this.effortService.update(effortSelected).subscribe(
          (effort) => {
            this.initialValues.find((e) => e.id === id).amount_deep = effortSelected.amount_deep;
            effortSelected.isEditingDeep = !effortSelected.isEditingDeep;
            this.remainigEffort(effortSelected);
            effortSelected.updating_deep = false;
          },
          (error) => {
            effortSelected.amount_deep = this.initialValues.find((e) => e.id === id).amount_deep;
          }
        );
      }
    }

    // this.effortService.update(effortSelected).subscribe(
    //   (effort) => {
    //     if (effortType === 'shore') {
    //       this.initialValues.find((e) => e.id === id).amount_shore = effortSelected.amount_shore;
    //       effortSelected.isEditingShore = !effortSelected.isEditingShore;
    //     } else if ((effortType = 'deep')) {
    //       this.initialValues.find((e) => e.id === id).amount_deep = effortSelected.amount_deep;
    //       effortSelected.isEditingDeep = !effortSelected.isEditingDeep;
    //     }
    //     this.remainigEffort(effortSelected);
    //   },
    //   (error) => {
    //     console.log(error);
    //     effortSelected.amount_shore = this.initialValues.find((e) => e.id === id).amount_shore;
    //     effortSelected.amount_deep = this.initialValues.find((e) => e.id === id).amount_deep;
    //   }
    // );
  }
  cancelEdit(id, effortType) {
    const effortSelected = this.collection.find((e) => e.id === id);

    if (effortType === 'shore') {
      effortSelected.amount_shore = this.initialValues.find((e) => e.id === id).amount_shore;
      effortSelected.isEditingShore = !effortSelected.isEditingShore;
    } else if ((effortType = 'deep')) {
      effortSelected.amount_deep = this.initialValues.find((e) => e.id === id).amount_deep;
      effortSelected.isEditingDeep = !effortSelected.isEditingDeep;
    }
  }

  applyFilter(params) {
    if (!this.loading) {
      this.params = params;
      const params_string = { year: params.year };
      const serialize_params = this.filter.serializeQueryParams(params_string);
      this.loading = true;
      this.effortService.list(1, 10000, serialize_params, '').subscribe((response) => {
        this.collection = [];
        for (const record of response.results) {
          this.collection.push(record);
        }
        if (this.profile.haveAccess('gestesfuerzos')) {
          this.getGestEfforts(serialize_params);
        }
        this.getInitialValues();
        this.loading = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/efforts/effort-list/effort-list.component.ts